import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	useContributorsDataQuery,
	type useContributorsDataQuery$data,
	type useContributorsDataQuery$variables,
} from '@confluence/contributors-macro/entry-points/useContributorsDataQuery.ts';
import { composeMacroParamsForQuery } from '@confluence/contributors-macro/entry-points/composeMacroParamsForQuery.ts';

import {
	type MacroContentNode,
	type MacroPreloadHandler,
	type MacroPreloadContext,
} from '../preloadMacroData.ts';

const buildVariables = (
	node: MacroContentNode,
	contentId: string,
): useContributorsDataQuery$variables => {
	const macroParams = node.attrs?.parameters?.macroParams;

	return {
		contentId,
		contentStatus: ['current'],
		contributorsMacroParameters: macroParams ? composeMacroParamsForQuery(macroParams) : undefined,
	};
};

/**
 * Preload handler for the contributors macro.
 *
 * For a contributors extension node found in the ADF content, this handler
 * builds query variables from the macro parameters and fires the
 * useContributorsDataQuery GraphQL query to populate the Relay store.
 */
export const contributorsPreloadHandler: MacroPreloadHandler = {
	extensionKey: 'contributors',

	routes: ['view', 'space-overview', 'edit', 'live'],

	preload: async (node: MacroContentNode, context: MacroPreloadContext): Promise<void> => {
		const variables = buildVariables(node, context.contentId);
		await query<useContributorsDataQuery$data, useContributorsDataQuery$variables>({
			query: useContributorsDataQuery,
			variables,
			context: { single: true },
		});
	},
};
